export default __webpack_public_path__ + "static/Portrait-Regular-Web-a2eeb4397afdf0f56f0e38fd2b183e1d.woff2";